import React from 'react';
import sectiondata from '../../data/sections.json';

export const AboutCardSection = () => {
  let publicUrl = process.env.PUBLIC_URL + '/'
  let imagealt = 'image'
  let data = sectiondata.aboutcardsection

  return (
    <div className="why-choose-us-area bg-gray pd-top-70 pd-bottom-90">
      <div className="container">
        <div className="section-title text-center">
          {/* <h2 className="title">{data.title}</h2> */}
        </div>
        
        <div className="row" style={{ maxWidth: '1000px', margin: '0 auto' }}>
          {/* What We Offer Column */}
          <div className="col-md-12">
            <div className="service-section" style={{ padding: '20px' }}>
              <h3 className="section-title" style={{
                fontSize: '22px',
                fontWeight: '600',
                color: '#333',
                marginBottom: '20px',
                
                borderBottom: '1px solid #eee'
              }}>
                What We Offer
              </h3>
              
              <div className="service-list">
                <div className="service-item" style={{  borderBottom: '1px solid #f5f5f5' }}>
                  <span style={{ fontWeight: '500' }}>Off-Plan Property Sales</span>
                </div>
                <div className="service-item" style={{  borderBottom: '1px solid #f5f5f5' }}>
                  <span style={{ fontWeight: '500' }}>Premium Residential & Commercial Listings</span>
                </div>
                <div className="service-item" style={{ borderBottom: '1px solid #f5f5f5' }}>
                  <span style={{ fontWeight: '500' }}>Investment Consultation & Portfolio Building</span>
                </div>
                <div className="service-item" style={{borderBottom: '1px solid #f5f5f5' }}>
                  <span style={{ fontWeight: '500' }}>Property Management & After-Sales Support</span>
                </div>
                <div className="service-item">
                  <span style={{ fontWeight: '500' }}>Partnerships with Leading Developers in Dubai</span>
                </div>
              </div>
            </div>
          </div>

          {/* Why Choose Us Column */}
          <div className="col-md-6">
            <div className="service-section" style={{ padding: '20px' }}>
              <h3 className="section-title" style={{
                fontSize: '22px',
                fontWeight: '600',
                color: '#333',
                marginBottom: '20px',
                borderBottom: '1px solid #eee'
              }}>
                Why Choose Us
              </h3>
              
              <div className="service-list">
                <div className="service-item" style={{ borderBottom: '1px solid #f5f5f5' }}>
                  <span style={{ fontWeight: '500' }}>Deep expertise in Dubai's real estate market</span>
                </div>
                <div className="service-item" style={{ borderBottom: '1px solid #f5f5f5' }}>
                  <span style={{ fontWeight: '500' }}>Strong network of trusted developers</span>
                </div>
                <div className="service-item" style={{ borderBottom: '1px solid #f5f5f5' }}>
                  <span style={{ fontWeight: '500' }}>Multilingual and culturally diverse team</span>
                </div>
                <div className="service-item" style={{ borderBottom: '1px solid #f5f5f5' }}>
                  <span style={{ fontWeight: '500' }}>End-to-end client support—from inquiry to key handover</span>
                </div>
                <div className="service-item">
                  <span style={{ fontWeight: '500' }}>Proven track record of helping investors succeed</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutCardSection;